/* eslint-disable space-infix-ops */
export const APP_KEY = 'easy_shipment_platform'
export const VERSION_NO = '1.0'
export const SHIP_KEY = '48d76846f7604e60a93be01185299f4b' // 船讯网key
// export const REQUEST_INTEFACE_URL = 'http://39.100.50.72:8086/' // 开发
// export const REQUEST_INTEFACE_URL = 'http://test.api.shipment.yichuanhuo.com/' // 测试
export const REQUEST_INTEFACE_URL = 'http://prod.api.shipment.yichuanhuo.com/' // 生产



// WEBPACK FOOTER //
// ./src/common/config.js